var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClosedAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.69922,
    width: 26,
    height: 20.4,
    rx: 5,
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6821 18.1272L20.1782 19.5876L19.8088 19.9463L20.1782 20.305L21.6821 21.7654L21.2454 22.1895L19.7196 20.7085L19.3712 20.3704L19.023 20.7086L17.498 22.1894L17.0605 21.7646L18.5636 20.305L18.9329 19.9464L18.5637 19.5876L17.0604 18.1272L17.498 17.7023L19.023 19.1832L19.3713 19.5215L19.7196 19.1832L21.2446 17.7023L21.6821 18.1272ZM11.2016 14.6863L11.2011 14.6863C10.049 14.6874 9.08658 15.5897 9.06956 16.7428C9.05253 17.8963 9.9885 18.8255 11.1404 18.8587C12.1914 18.889 13.1079 18.1643 13.3003 17.1617H13.3356V16.8443V16.7729C13.3356 15.6068 12.3662 14.6863 11.2016 14.6863ZM7.46822 24.9996H6.82991C7.08519 22.893 8.93332 21.2396 11.2016 21.2396C13.4699 21.2396 15.318 22.893 15.5733 24.9996H14.935C14.6843 23.1973 13.0968 21.8263 11.2016 21.8263C9.3064 21.8263 7.71898 23.1973 7.46822 24.9996ZM11.2014 19.4463C9.6589 19.4462 8.43374 18.2356 8.43374 16.7729C8.43374 15.3102 9.65902 14.0996 11.2016 14.0996C12.7441 14.0996 13.9693 15.3101 13.9695 16.7727C13.9674 18.2347 12.7432 19.4442 11.2014 19.4463Z",
    fill: "#D2DAE4",
    stroke: "#8F27C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.7L21 8C21 4.13401 17.866 1 14 1V1C10.134 1 7 4.13401 7 8L7 8.7",
    stroke: "#8F27C7",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClosedAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/closed-account.9df90ed35c8f47eb9dda449d39ede1ee.svg";